import { render, staticRenderFns } from "./o-awards-v2.vue?vue&type=template&id=2d7b737b&scoped=true"
import script from "./o-awards-v2.vue?vue&type=script&lang=js"
export * from "./o-awards-v2.vue?vue&type=script&lang=js"
import style0 from "./o-awards-v2.vue?vue&type=style&index=0&id=2d7b737b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7b737b",
  null
  
)

export default component.exports